"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTcolApiAllowed = exports.ALLOWED_TCOLAPI_HOST = exports.redirectIE2NotSuported = exports.getMsieVersion = exports.getMockedContext = exports.calculateNetworkParams = exports.tranformXcol2Ip3Hashes = exports.mergeIp3gHashes = exports.composeI3Object = exports.createBasicContext = exports.checkSegment = exports.generatePageId = exports.getTabId = exports.isProdBucket = exports.isQaEnv = exports.isLocalHost = exports.buildViewData = exports.setSegmentCookie = exports.isTelcoBuyProcess = exports.isTelcoSite = exports.isNovum = exports.QUEUE_NAME = void 0;
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
exports.QUEUE_NAME = "Metrics";
const isNovum = (throwSonda) => {
    try {
        return sessionStorage.getItem("canalVenta") === "appNovum";
    }
    catch (err) {
        throwSonda({
            processName: "isNovum",
            severidad: "WARNING",
            info: null,
            error: err,
            context,
        });
        return null;
    }
};
exports.isNovum = isNovum;
const isTelcoSite = () => {
    return window.location.href.indexOf("cliente/areaprivada/#") >= 0;
};
exports.isTelcoSite = isTelcoSite;
const isTelcoBuyProcess = () => {
    return (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra") >= 0);
};
exports.isTelcoBuyProcess = isTelcoBuyProcess;
const setSegmentCookie = (segment, throwSonda) => {
    try {
        if (segment) {
            (0, next12_utils_common_1.setCookie)("SEG_NAV", segment, 30);
        }
        // fixing errors
    }
    catch (e) {
        throwSonda({
            processName: "setSegmentCookie",
            severidad: "WARNING",
            info: null,
            error: e,
        });
    }
};
exports.setSegmentCookie = setSegmentCookie;
const buildViewData = (data) => {
    let { "user-type": userType } = data;
    let contextUserRole = "";
    if (userType === "Gestor") {
        userType = "Telco";
        contextUserRole = "gestor";
    }
    return Object.assign(Object.assign({}, data), { "context-user-role": contextUserRole, "user-type": userType });
};
exports.buildViewData = buildViewData;
const isLocalHost = () => {
    let res = false;
    try {
        res = window.location.href.indexOf("127.0.0.1") > -1;
    }
    catch (err) {
        return res;
    }
    return res;
};
exports.isLocalHost = isLocalHost;
const isQaEnv = () => {
    let res = false;
    try {
        res =
            window.location.href.indexOf("movistar.es.cert") > -1 ||
                window.location.href.indexOf("qa.cms.col.movistar.es") > -1 ||
                window.location.href.indexOf("col10mgmt.tsm.inet") > -1;
        return res;
    }
    catch (err) {
        return res;
    }
};
exports.isQaEnv = isQaEnv;
const isProdBucket = () => {
    let res = false;
    try {
        res = window.location.href.indexOf("prod.cms.col.movistar.es") > -1;
        return res;
    }
    catch (err) {
        return res;
    }
};
exports.isProdBucket = isProdBucket;
/**
 * Comprueba si existe tabId
 * @returns {boolean}
 */
const existsTabId = () => {
    try {
        if (window.sessionStorage) {
            return sessionStorage.getItem("mov_tabID") !== null;
        }
        return null;
    }
    catch (err) {
        return null;
    }
};
/**
 * Genera un id para la pestaña actual del navegador.
 * @returns {number}
 */
const generateTabId = () => {
    const tabId = Date.now(); // Todo
    try {
        if (window.sessionStorage) {
            sessionStorage.setItem("mov_tabID", tabId);
            return sessionStorage.getItem("mov_tabID");
        }
        return `notSupportedSessionStorage-${tabId}`;
    }
    catch (err) {
        return `notSupportedSessionStorage-${tabId}`;
    }
};
/**
 * Obtiene el tabId de la pestaña actual.
 * @returns {func}
 */
const getTabId = () => {
    if (existsTabId()) {
        return sessionStorage.getItem("mov_tabID");
    }
    return generateTabId();
};
exports.getTabId = getTabId;
const newID = () => {
    return Math.random().toString(36).substr(2, 9);
};
const generatePageId = () => {
    const uuidArray = [];
    for (let i = 0; i < 6; i++) {
        uuidArray.push(newID());
    }
    return uuidArray.join("-");
};
exports.generatePageId = generatePageId;
/**
 * Returns page segment
 * @return {string} 'particulares' by default
 */
const checkSegment = () => {
    let res = "";
    // intentamos por url empresas
    const { pathname } = window.location;
    if (pathname.indexOf("/empresas") === 0) {
        res = "empresas";
    }
    // intentamos por url particulares
    if (pathname.indexOf("/particulares") === 0 ||
        pathname.indexOf("/cliente/areaprivada") === 0) {
        res = "particulares";
    }
    const cookieNav = getCookie("SEG_NAV");
    if (!res && cookieNav && cookieNav !== "") {
        res = cookieNav;
    }
    // en caso de no detectar por url, y en caso de que la cookie venga vacía
    if (!res) {
        res = "particulares";
    }
    return res;
};
exports.checkSegment = checkSegment;
/**
 * Comprueba si hay alguna clave de keys en el objecto que se ha pasado
 * para actualizar objectToCompare
 * @param {Object} objectToSearch objeto donde buscar las claves.
 * @param {*} keys claves que nos importan estas dependerán de la cola en la que estemos
 * @param {*} objectToCompare estructura completa que tenemos en context
 * @returns {boolean}
 */
const createBasicContext = () => __awaiter(void 0, void 0, void 0, function* () {
    const environmentImport = yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.environment")));
    const { findOutEnv } = environmentImport;
    const environment = findOutEnv();
    const context = {
        environment,
    };
    return context;
});
exports.createBasicContext = createBasicContext;
/**
 * Obtiene la info de hashes de cliente desglosada
 * @param {object} ip3gResponse
 * @returns {object}
 */
const composeI3Object = (ip3gResponse) => {
    const i3DssObj = ip3gResponse || {};
    /* OTROS QUE NO INTERPRETAMOS DE MOMENTO */
    // const i3D = i3DssObj.d ? i3DssObj.d : '';
    // const i3F = i3DssObj.f ? i3DssObj.f : '';
    // const i3I = i3DssObj.i ? i3DssObj.i : '';
    // const i3K = i3DssObj.k ? i3DssObj.k : '';
    // const i3M = i3DssObj.m ? i3DssObj.m : '';
    // const i3O = i3DssObj.o ? i3DssObj.o : '';
    /* HASHES QUE INTERPRETAMOS */
    const i3A = i3DssObj.a ? i3DssObj.a : "";
    const i3I3I = i3DssObj.i3i ? i3DssObj.i3i : ""; // EL ADICIONAL
    const i3X = i3DssObj.x ? i3DssObj.x : "";
    const i3Z = i3DssObj.z ? i3DssObj.z : "";
    const i3C = i3DssObj.c ? i3DssObj.c : "";
    const i3L = i3DssObj.l ? i3DssObj.l : "";
    const i3P = i3DssObj.p ? i3DssObj.p : "";
    const i3T = i3DssObj.t ? i3DssObj.t : "";
    const i3G = i3DssObj.g ? i3DssObj.g : "";
    /* MAPEO A CONTEXT */
    return {
        userCUCFijoHash: i3C,
        userCUCMovilHash: i3L,
        userCUCPrepagoHash: i3P,
        userIPHash: i3A,
        userOperadorHash: i3X,
        userGl: i3I3I,
        userTelefonoFijoHash: i3T,
        userTelefonoMovilHash: i3G,
        userIdPartyHash: i3Z,
        userClient: !!(i3C || i3L || i3P || i3A || i3T || i3G),
    };
};
exports.composeI3Object = composeI3Object;
/**
 * Combina los valores del ip3g entre las respuestas de servicio y los de IC
 * @param {object} IcHashes
 * @param {object} serviceHashes
 * @returns {object}
 */
const mergeIp3gHashes = (IcHashes, serviceHashes) => {
    const result = Object.assign({}, serviceHashes);
    const keys = Object.keys(IcHashes);
    keys.forEach((keyName) => {
        if (IcHashes[keyName]) {
            result[keyName] = IcHashes[keyName];
        }
    });
    return result;
};
exports.mergeIp3gHashes = mergeIp3gHashes;
/**
 * Transforma el string de xcol a ip3hashes
 * @param {string} IcHashes
 * @returns {object}
 */
const tranformXcol2Ip3Hashes = (xcol) => {
    let res = xcol;
    res = window.atob(res.split(".")[1]);
    res = JSON.parse(res);
    res = (0, exports.composeI3Object)(res);
    return res;
};
exports.tranformXcol2Ip3Hashes = tranformXcol2Ip3Hashes;
/**
 * Calcula valores relacionados con la velocidad de conectividad
 * @returns {object}
 * {
 *  delay: int => tiempo para que aparezca las ondas grises
 *  timeOut: int => tiempo para que se muestre pantalla error de conexión
 * }
 */
const calculateNetworkParams = () => {
    let delay = 1000;
    let timeout = 5000;
    let type = "4g";
    try {
        const connection = navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
        type = connection.effectiveType;
        switch (type) {
            case "slow-2g":
                timeout = 20000;
                delay = 10000;
                break;
            case "2g":
                timeout = 18000;
                delay = 9000;
                break;
            case "3g":
                timeout = 15000;
                delay = 7500;
                break;
            case "4g":
            default:
                timeout = 10000;
                delay = 5000;
                break;
        }
    }
    catch (err) {
        return { timeout, delay, type };
    }
    return { timeout, delay, type };
};
exports.calculateNetworkParams = calculateNetworkParams;
/**
 * Obtiene la variable 'mockedContext' del sessionStorage
 * @returns {object} Objeto con los valores de mockedContext (null si no existe)
 */
const getMockedContext = (envName = "prod") => {
    if (envName !== "prod") {
        try {
            const mockString = sessionStorage.getItem("mockedContext");
            const mock = JSON.parse(mockString);
            if (mock) {
                return mock;
            }
            return {};
        }
        catch (err) {
            return {};
        }
    }
    return {};
};
exports.getMockedContext = getMockedContext;
const getMsieVersion = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    return msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./);
};
exports.getMsieVersion = getMsieVersion;
const redirectIE2NotSuported = () => {
    let rightPath = false;
    const movistarHost = window.location.host.indexOf("movistar.es") > -1;
    const firstPathToken = window.location.pathname.split("/")[1];
    const IE_PATHS = ["particulares", "empresas", "autonomos", ""];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < IE_PATHS.length; i++) {
        if (!rightPath && firstPathToken === IE_PATHS[i]) {
            rightPath = true;
        }
    }
    if (movistarHost && (0, exports.getMsieVersion)() && rightPath) {
        window.location.pathname = "/navegador-no-soportado";
    }
};
exports.redirectIE2NotSuported = redirectIE2NotSuported;
exports.ALLOWED_TCOLAPI_HOST = [
    "col10mgmt.tsm.inet",
    "movistar.es",
    "www.movistar.es",
    "movistar.cert",
    "www.movistar.cert",
];
const checkTcolApiAllowed = () => {
    let res = false;
    if (window && window.location && window.location.host) {
        const { host } = window.location;
        // 1) si contiene cms.col
        if (host.indexOf(".cms.col") > -1) {
            res = true;
        }
        // 2) si es algo de los hosts
        if (!res && exports.ALLOWED_TCOLAPI_HOST.includes(host)) {
            res = true;
        }
    }
    return res;
};
exports.checkTcolApiAllowed = checkTcolApiAllowed;
//# sourceMappingURL=utils.js.map